<template>
    <div class="py-0 mt-4 mb-8">
        <v-container class="mx-0 my-0" style="padding:0 !important; max-width: 100% !important">
            <v-card class="mt-1 pt-1 pb-10 px-0 size" style="margin-bottom: 35px !important" align="center" v-if="appointment != null">
                <v-row class="px-0 py-4 text-center" justify="center" align="center">
                    <v-col cols="6" class="py-1" justify="center" align="center">
                        <span justify="center" class="pr-1 blue_accent--text font-weight-bold" style="font-size:18px">
                            {{ $t('register_in_process.start_to_process') }} 
                        </span> 
                    </v-col>
                </v-row>
                <v-col cols="6" justify="start" align="start" class="px-0">
                    <v-row>
                        <v-col cols="6" class="py-1">
                            <span justify="center" class="pr-1 blue_accent--text font-weight-bold" style="font-size:18px">
                                {{ $t('register_in_process.general_data') }} 
                            </span>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('register_in_process.appointment') }}: </span> {{ this.id }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('register_in_process.client') }}: </span> {{ this.appointment.client.name }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('register_in_process.estimated_date_of_arriving') }}: </span> {{ this.appointment.arrival_date }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col v-if="$store.state.language == 'es'" cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('register_in_process.operation') }}: </span> {{ this.appointment.operation.description }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col v-if="$store.state.language == 'en'" cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('register_in_process.operation') }}: </span> {{ this.appointment.operation.description1 }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('register_in_process.container') }}: </span> {{ this.appointment.container_number }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('register_in_process.description') }}: </span> {{ this.appointment.description }} </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" class="py-0"><span justify="center" class="pr-1 blue_accent--text font-weight-bold">{{ $t('register_in_process.comments') }}: </span> {{ this.appointment.commentary }} </v-col>
                    </v-row>
                </v-col>
                <v-col class="py-5 px-0" cols="6" justify="start" align="start">
                    <v-row>
                        <v-col cols="12" class="py-1">
                            <span justify="center" class="pr-1 blue_accent--text font-weight-bold" style="font-size:18px">
                                {{ $t('register_in_process.products') }} 
                            </span>
                        </v-col>
                    </v-row>
                    <datatable :props="{headers:headers_sku, items: products}" @methodHandler="methodHandler"></datatable>
                </v-col>
                <v-col class="py-5 px-0" cols="6" justify="start" align="start">
                    <v-row>
                        <v-col cols="12" class="py-1">
                            <span justify="center" class="pr-1 blue_accent--text font-weight-bold" style="font-size:18px">
                            {{ $t('register_in_process.transport_details') }} 
                            </span>
                        </v-col>
                    </v-row>
                </v-col>
                <v-form ref="form" lazy-validation @submit.prevent="update">
                    <v-col cols="6" align="center" justify="center" class="px-0 py-0">
                        <v-row class="px-0 py-0" justify="center" align="center">
                            <v-col cols="12" class="py-0">
                                <v-autocomplete :items="tipos_carga" v-model="appointment.cargo_type" :rules="rules_required" :label="$t('register_in_process.type_of_cargo')"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="px-3 pb-2" justify="start" align="center">
                            <v-col cols="8" class="px-0 py-0" justify="start" align="start">
                                <span >{{ $t('register_in_process.merchandise_good_conditions') }}:</span>
                            </v-col>
                            <v-col cols="4" class="px-0 py-0" justify="end" align="end">
                                <v-btn class="radio-left white--text" v-bind:color="appointment.merchandise_good_conditions == 0 ? 'blue_accent' : 'grey'" @click="appointment.merchandise_good_conditions = 0">{{ $t('register_in_process.false') }}</v-btn>
                                <v-btn class="radio-right white--text" v-bind:color="appointment.merchandise_good_conditions == 1? 'blue_accent' : 'grey'" @click="appointment.merchandise_good_conditions = 1">{{ $t('register_in_process.true') }}</v-btn>
                            </v-col>
                        </v-row> 
                        <v-row class="px-3 pb-2" justify="start" align="center">
                            <v-col cols="8" class="px-0 py-0" justify="start" align="start">
                                <span>{{ $t('register_in_process.packaging_complies_conditions') }}:</span>
                            </v-col>
                            <v-col cols="4" class="px-0 py-0" justify="end" align="end">
                                <v-btn class="radio-left white--text" v-bind:color="appointment.packaging_complies_conditions == 0 ? 'blue_accent' : 'grey'" @click="appointment.packaging_complies_conditions = 0">{{ $t('register_in_process.false') }}</v-btn>
                                <v-btn class="radio-right white--text" v-bind:color="appointment.packaging_complies_conditions == 1? 'blue_accent' : 'grey'" @click="appointment.packaging_complies_conditions = 1">{{ $t('register_in_process.true') }}</v-btn>
                            </v-col>    
                        </v-row>
                    </v-col>
                </v-form>
                <v-row align="center" justify="center" class="mt-4">
                    <v-col class="mb-1" cols="6" align="end" justify="center">
                        <btn-sf :label="'register_in_process.cancel'" @click="cancel" class="mr-2"></btn-sf>
                        <btn-sf :label="'register_in_process.remove_of_portal'" @click="toOnPremises" v-permission="'op_on_premises.update'" class="mr-2"></btn-sf>
                        <btn-sf :label="'register_in_process.process_container'" :disabled="appointment.status != 'En rampa' || !can_continue" @click="update('in-process')" v-permission="'op_on_premises.update'" class="mr-2"></btn-sf>
                        <btn-pf :label="'register_in_process.process_and_continue'" :disabled="appointment.status != 'En rampa' || !can_continue" @click="update('end-process')" v-permission="'op_on_premises.update'"></btn-pf> 
                    </v-col>  
                </v-row>
            </v-card>
            <bottom-bar ref="bottombar" :from="from" :m_type="m_type"></bottom-bar>
        </v-container>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>
import { appointmentShowUseCase } from '../../application/use_cases/appointment_show_use_case';
import { appointmentSetStatusUseCase } from '../../application/use_cases/appointment_set_status_use_case';
import { HttpAppointmentRepository } from '../../infrastructure/appointment_repository';

export default {
    computed: {
        headers_sku: function(){
            return [
                {text: this.$t('process_pendings.sku'), value: 'sku_p', class: 'text-uppercase'},
                // {text: this.$t('edit_appointment.description'), value: 'descripcion', class: 'text-uppercase'},
                {text: this.$t('process_pendings.quantity'), value: 'quantity', class: 'text-uppercase'},
                {text: this.$t('process_pendings.unit'), value: 'unit', class: 'text-uppercase'}
            ];
        },
        rules_required(){return [v => !!v || this.$t('edit_appointment.validations.required_field')]}, 
        numeric(){return [v => /^(|\d)+$/.test(v) || this.$t('register_in_process.validations.numbers'),];} 
    },
    data(){
        return {
            id: this.$route.params.id,
            from: this.$route.params.from,
            m_type: this.$route.params.m_type,
            snackbar: {
                visible: false,
                color: 'primary',
                timeout: 2000,
                text: ''
            },
            tipos_carga: [
                { text: this.$t("register_in_process.forklift"), value: "MONTACARGA" },
                { text: this.$t("register_in_process.manually"), value: "MANUAL" },
                { text: this.$t("register_in_process.crane"), value: "GRUA" },
                { text: this.$t("register_in_process.none"), value: "NINGUNA" }
            ],
            appointment: null,
            products: [],
            can_continue: true
        }
    },
    mounted(){
        localStorage.setItem('bottom', 2);
        this.$store.state.bottom = 2;
        this.$store.state.module = "headers.in_process_operation";
        this.index();
    },
    methods: {
        cancel(){
            this.$router.push('/operation/on-ramp/' + this.from + '/' + this.m_type);
        },
        methodHandler(object){
            this[object.methodName](object.parameters);
        },
        async index(){
            try{
                this.appointment = await appointmentShowUseCase(this.id, HttpAppointmentRepository);

                await this.loadProducts();
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        async loadProducts() {
            if(this.appointment.operation.format_type == "Entrada"){
                if(this.appointment.unknown_products == true){
                    var p = {};
                    if(this.appointment.standby_products[0].attributes.unknownProducts.boxes > 0){
                        console.log("OKOKK")
                        p = {
                            sku_p: this.$t('process_pendings.boxes'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.boxes
                        }
                        this.products.push(p);
                    }
                    else if(this.appointment.standby_products[0].attributes.unknownProducts.pallets > 0){
                        p = {
                            sku_p: this.$t('process_pendings.pallets'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.pallets
                        }
                        this.products.push(p);
                    }
                    else if(this.appointment.standby_products[0].attributes.unknownProducts.containers > 0){
                        p = {
                            sku_p: this.$t('process_pendings.containers'),
                            quantity: this.appointment.standby_products[0].attributes.unknownProducts.containers
                        }
                        this.products.push(p);
                    }
                }
                else{
                    this.appointment.standby_products.forEach(x => 
                    {
                        x = x.attributes;
                        var p = {};
                        p = {
                            sku_p: x.product.sku,
                            quantity: x.quantity,
                            unit: x.product.unit
                        }
                                    
                        this.products.push(p);
                    });
                }
            } 
            else if(this.appointment.operation.format_type == "Salida"){
                this.appointment.detail_orders.forEach(x => 
                {
                    x = x.attributes;
                    var p = {};
                    p = {
                        sku_p: x.product.sku,
                        quantity: x.expected,
                        unit: x.product.unit
                    }
                                
                    this.products.push(p);
                });
            }
        },
        async update(url){
            const valid = this.$refs.form.validate();
            
            if(valid){
                try{
                    const appointment = {
                        status: 'Procesando',
                        newStatus: 'Procesando',
                    }
                    const res = await appointmentSetStatusUseCase(this.id, appointment, HttpAppointmentRepository);
                    res;
                    
                    if(url== "in-process") this.$router.push('/operation/' + url + '/' + this.from + '/' + this.m_type);
                    else this.$router.push('/operation/' + url + '/' + this.id + '/' + this.from + '/' + this.m_type);
                } catch (e) {
                    console.log(e);
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: e.response == null? e : e.response.data.message
                    }
                }
            }
            else{
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('register_in_portal.responses.empty')
                }
            }
        },
        async toOnPremises(){
            try{
                const appointment = {
                    gate_id: null,
                    status: 'En recinto',
                    newStatus: 'En recinto',
                }
                
                const res = await appointmentSetStatusUseCase(this.id, appointment, HttpAppointmentRepository);
                res;
                
                this.$router.push('/operation/on-enclosure/' + this.from + '/' + this.m_type);
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.message
                }
            }
        },
    },
    watch:{
    }
}
</script>